import axios from 'axios';
import config from '@/config';

const instance = axios.create({
  baseURL:
    process.env.NODE_ENV === 'development' ? '/platformapi/' : config.PLATFORM_API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export default instance;
